export function GetPicturePath(id: string): string {
  return `submitted/pictures/${id}`;
}

export function GetFormPicturePath(id: string): string {
  return `pictures/${id}`;
}

export const formDefinition = {
}

export const fieldTypes = [
  { label: "Text", value: "text" },
  { label: "Textarea", value: "textarea" },
  { label: "Radio", value: "radio" },
  { label: "Checkbox", value: "checkbox" },
  { label: "Date", value: "date" },
  { label: "Upload", value: "upload" },
];
